export default "__VITE_ASSET__DWvqJoFs__"